import { fadeInScaleUpTransition as a } from "../../../_styles/transitions/fade-in-scale-up.cssr.js";
import { c as e, cB as o } from "../../../_utils/cssr/index.js";
const r = e([o("auto-complete", `
 z-index: auto;
 position: relative;
 display: inline-flex;
 width: 100%;
 `), o("auto-complete-menu", `
 margin: 4px 0;
 box-shadow: var(--n-menu-box-shadow);
 `, [a({
  originalTransition: "background-color .3s var(--n-bezier), box-shadow .3s var(--n-bezier)"
})])]);
export {
  r as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/auto-complete/src/styles/index.cssr.js
// module id = 1589
// module chunks = 41